import { CHANGE_EMAIL_VERIFY, FORGOT_PASS, JOIN_GUEST, RESET_PASS, SIGN_IN, SIGN_OUT, SIGN_UP, VALIDATE_EMAIL, VERIFY_CHANGE_EMAIL, VERIFY_EMAIL, VERIFY_TWO_STEP_AUTH } from '../../constants';
import fetch from '../../fetch';

function signIn({ email, password, invitationToken })
{
	return fetch(SIGN_IN, {
		method: 'POST',
		body: JSON.stringify({ email, password, invitationToken })
	});
}

function validateExistingEmail(email)
{
	return fetch(`${VALIDATE_EMAIL}?email=${email}`);
}

function signOut()
{
	return fetch(SIGN_OUT, { method: 'DELETE' });
}

function signUp({ email, password, name, type, role, company, firstName, lastName, invitationToken, passcode })
{
	return fetch(SIGN_UP, {
		method: 'POST',
		body: JSON.stringify({ email, password, name, type, role, company, firstName, lastName, invitationToken, passcode })
	});
}

function verifyEmail(token)
{
	return fetch(VERIFY_EMAIL, {
		method: 'POST',
		body: JSON.stringify({ token })
	});
}

function verifyChangeEmail(token)
{
	return fetch(VERIFY_CHANGE_EMAIL, {
		method: 'POST',
		body: JSON.stringify({ token })
	});
}

function forgotPass(email)
{
	return fetch(FORGOT_PASS, {
		method: 'POST',
		body: JSON.stringify({ email })
	});
}

function changeEmailVerification()
{
	return fetch(CHANGE_EMAIL_VERIFY);
}

function changeEmail(email, token)
{
	return fetch(CHANGE_EMAIL_VERIFY, {
		method: 'POST',
		body: JSON.stringify({ email, token })
	});
}

function resetPass(password, token)
{
	return fetch(RESET_PASS, {
		method: 'POST',
		body: JSON.stringify({ password, token })
	});
}

function joinAsGuest({ firstName, lastName, email, token, passcode })
{
	return fetch(JOIN_GUEST, {
		method: 'POST',
		body: JSON.stringify({ firstName, lastName, email, token, passcode })
	});
}

function verifyTwoStepAuth(code)
{
	return fetch(VERIFY_TWO_STEP_AUTH, {
		method: 'POST',
		body: JSON.stringify({ code })
	});
}

export { signIn, signUp, signOut, verifyEmail, verifyChangeEmail, forgotPass, resetPass, joinAsGuest,
	verifyTwoStepAuth, changeEmailVerification, changeEmail, validateExistingEmail };
